import { render, staticRenderFns } from "./NoMaster.vue?vue&type=template&id=3fa1111e"
import script from "./NoMaster.vue?vue&type=script&lang=js"
export * from "./NoMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports